
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Spinner887901018",
      {"classes":{"root":"Spinner887901018__root","circle":"Spinner887901018__circle"},"vars":{"wix-color-5":"--wix-color-5","wix-ui-tpa-spinner-path-color":"--wix-ui-tpa-spinner-path-color","wix-ui-tpa-spinner-diameter":"--wix-ui-tpa-spinner-diameter","diameter":"--Spinner887901018-diameter"},"stVars":{},"keyframes":{"rotate":"Spinner887901018__rotate","dash":"Spinner887901018__dash"},"layers":{}},
      "",
      -1,
      module.id
  );
  